'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reduxRouter = require('redux-router');

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _components = require('components');

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _reactBootstrap = require('react-bootstrap');

var _notifications = require('redux/modules/notifications');

var notificationActions = _interopRequireWildcard(_notifications);

var _utils = require('utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notification = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destroyed: state.notifications.destroyed,
    notifications: state.notifications.notifications,
    error: state.notifications.error,
    queryParams: state.notifications.queryParams,
    router: state.router,
    urlQuery: state.router.location.query,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, notificationActions, { push: _reduxRouter.push })), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Notification, _Component);

  function Notification(props, context, updater) {
    (0, _classCallCheck3.default)(this, Notification);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Notification.__proto__ || (0, _getPrototypeOf2.default)(Notification)).call(this, props, context, updater));

    _this.state = {
      snackbar: (0, _utils.snackbarInitialState)(),
      requestModalOpen: false,
      eventId: null,
      isModalOpen: false,
      selectedNotification: {
        entry: {
          item: {
            title: ''
          }
        }
      }
    };
    return _this;
  }

  (0, _createClass3.default)(Notification, [{
    key: 'handleArchive',
    value: function handleArchive(notificationId) {
      var _this2 = this;

      var _props = this.props,
          archive = _props.archive,
          locale = _props.user.lang;


      var phrases = require('./../../locales/' + locale + '/notification.js');
      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: phrases
      });
      archive(notificationId).then(function (res) {
        if (res.type === notificationActions.DESTROY_SUCCESS) {
          var snackbar = _this2.state.snackbar;


          snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
            $merge: {
              action: false,
              dismissAfter: 2000,
              id: notificationId,
              isActive: true,
              message: polyglot.t('snackbar.notification.archived')
            }
          });

          _this2.setState({ snackbar: snackbar });
        }
      });
    }
  }, {
    key: 'handleCloseRequestModal',
    value: function handleCloseRequestModal() {
      this.setState({ requestModalOpen: false });
    }
  }, {
    key: 'showEventModal',
    value: function showEventModal(eventId) {
      this.setState({
        eventId: eventId,
        isModalOpen: true
      });
    }
  }, {
    key: 'closeEventModal',
    value: function closeEventModal() {
      this.setState({
        eventId: null,
        isModalOpen: false
      });
    }
  }, {
    key: 'handleDecline',
    value: function handleDecline(notification) {
      this.setState({
        requestModalOpen: true,
        selectedNotification: notification
      });
    }
  }, {
    key: 'handleDestroy',
    value: function handleDestroy(notificationId) {
      var _this3 = this;

      var _props2 = this.props,
          destroy = _props2.destroy,
          locale = _props2.user.lang;


      var phrases = require('./../../locales/' + locale + '/notification.js');
      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: phrases
      });
      destroy(notificationId).then(function (res) {
        if (res.type === notificationActions.DESTROY_SUCCESS) {
          var snackbar = _this3.state.snackbar;


          snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
            $merge: {
              action: 'undo',
              dismissAfter: 25000,
              id: notificationId,
              isActive: true,
              message: polyglot.t('snackbar.notification.destroyed')
            }
          });

          _this3.setState({ snackbar: snackbar });
        }
      });
    }
  }, {
    key: 'hideSnackbar',
    value: function hideSnackbar() {
      var snackbar = this.state.snackbar;


      snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
        $merge: {
          id: 0,
          isActive: false
        }
      });

      this.setState({ snackbar: snackbar });
    }
  }, {
    key: 'handleDismissSnackbar',
    value: function handleDismissSnackbar() {
      this.hideSnackbar();
    }
  }, {
    key: 'handleClickSnackbar',
    value: function handleClickSnackbar() {
      var _this4 = this;

      var _props3 = this.props,
          restore = _props3.restore,
          destroyed = _props3.destroyed;


      restore(destroyed.id).then(function (res) {
        if (res.type === notificationActions.RESTORE_SUCCESS) {
          _this4.hideSnackbar();
        }
      });
    }
  }, {
    key: 'handlePublish',
    value: function handlePublish(notification) {
      var publish = this.props.publish;


      publish(notification.id);
    }
  }, {
    key: 'handleSendDecline',
    value: function handleSendDecline(notification, message) {
      var _this5 = this;

      var decline = this.props.decline;


      decline(notification.id, message).then(function (res) {
        if (res.type === notificationActions.DESTROY_SUCCESS) {
          _this5.setState({
            requestModalOpen: false
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props4 = this.props,
          notifications = _props4.notifications,
          router = _props4.router,
          locale = _props4.user.lang;

      var phrases = require('./../../locales/' + locale + '/notification.js');
      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: phrases
      });
      _moment2.default.locale(polyglot.locale, require('./../../locales/' + locale + '/calendar.js'));
      var _state = this.state,
          snackbar = _state.snackbar,
          requestModalOpen = _state.requestModalOpen,
          selectedNotification = _state.selectedNotification;

      var isArchivedPage = router.location.pathname === '/notifications/archived';

      var notificationItems = notifications.data.length ? notifications.data.map(function (notification, index) {
        return _react2.default.createElement(_components.NotificationItem, {
          key: index,
          notification: notification,
          btnDestroy: _react2.default.createElement(_components.NotificationButtonDestroy, {
            handleDestroy: isArchivedPage ? _this6.handleDestroy.bind(_this6) : _this6.handleArchive.bind(_this6),
            notificationId: notification.id
          }),
          isArchivedPage: isArchivedPage,
          handleArchive: _this6.handleArchive.bind(_this6),
          handleDestroy: _this6.handleDestroy.bind(_this6),
          handleDecline: _this6.handleDecline.bind(_this6),
          handlePublish: _this6.handlePublish.bind(_this6),
          polyglot: polyglot,
          showEventModal: _this6.showEventModal.bind(_this6)
        });
      }) : polyglot.t('notification.empty');

      var pages = {
        prev: 0,
        next: 2
      };

      var pagerPrevDisabled = true;
      var pagerNextDisabled = true;

      var showPager = (0, _classnames2.default)({
        hide: true
      });

      var count = {
        notifications: ''
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactDocumentMeta2.default, { title: polyglot.t('notification.meta_title') }),
        _react2.default.createElement(
          'div',
          { className: 'header' },
          _react2.default.createElement(
            'h1',
            null,
            polyglot.t('notification.title')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'filters' },
          _react2.default.createElement(
            'ul',
            { className: 'nav nav-pills' },
            _react2.default.createElement(
              'li',
              { role: 'presentation', className: !isArchivedPage && 'active' },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/notifications' },
                polyglot.t('notification.nav.new'),
                ' ',
                count.notifications
              )
            ),
            _react2.default.createElement(
              'li',
              { role: 'presentation', className: isArchivedPage && 'active' },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/notifications/archived', query: { page: 1 } },
                polyglot.t('notification.nav.archived')
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'results' },
          notificationItems
        ),
        _react2.default.createElement(
          _reactBootstrap.Pager,
          { onSelect: this.onPagerSelect, className: showPager },
          _react2.default.createElement(
            _reactBootstrap.Pager.Item,
            { disabled: pagerPrevDisabled, eventKey: { page: pages.prev }, href: '#?previous' },
            polyglot.t('pager.prev')
          ),
          '\xA0',
          _react2.default.createElement(
            _reactBootstrap.Pager.Item,
            { disabled: pagerNextDisabled, eventKey: { page: pages.next }, href: '#?next' },
            polyglot.t('pager.next')
          )
        ),
        _react2.default.createElement(_components.EventModal, {
          isModalOpen: this.state.isModalOpen,
          closeModal: this.closeEventModal.bind(this),
          eventId: this.state.eventId,
          polyglot: polyglot
        }),
        _react2.default.createElement(_components.NotificationRequestModal, {
          show: requestModalOpen,
          closeModal: this.handleCloseRequestModal.bind(this),
          polyglot: polyglot,
          selectedNotification: selectedNotification,
          sendDecline: this.handleSendDecline.bind(this)
        }),
        _react2.default.createElement(_components.Snackbar, (0, _extends3.default)({
          ref: 'snackbar'
        }, snackbar, {
          style: (0, _utils.snackbarStyle)(),
          onDismiss: this.handleDismissSnackbar.bind(this),
          onClick: this.handleClickSnackbar.bind(this),
          polyglot: polyglot

        }))
      );
    }
  }], [{
    key: 'fetchData',
    value: function fetchData(getState, dispatch, location) {
      var state = getState();
      var isArchivedPage = location.pathname === '/notifications/archived';
      var queryParams = state.notifications.queryParams;


      var parsedParams = _queryString2.default.parse(location.search);

      if (queryParams !== parsedParams) {
        dispatch((0, _notifications.forceReload)('1'));
      }

      queryParams = (0, _extends3.default)({}, queryParams, parsedParams);

      if (!(0, _notifications.isLoaded)(getState())) {
        return dispatch((0, _notifications.load)(queryParams, isArchivedPage));
      }
    }
  }]);
  return Notification;
}(_react.Component), _class2.propTypes = {
  archive: _propTypes2.default.func.isRequired,
  decline: _propTypes2.default.func.isRequired,
  destroy: _propTypes2.default.func.isRequired,
  destroyed: _propTypes2.default.object,
  error: _propTypes2.default.any,
  forceReload: _propTypes2.default.func.isRequired,
  load: _propTypes2.default.func,
  notifications: _propTypes2.default.object,
  publish: _propTypes2.default.func.isRequired,
  push: _propTypes2.default.func.isRequired,
  queryParams: _propTypes2.default.object,
  restore: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.any,
  urlQuery: _propTypes2.default.any,
  user: _propTypes2.default.object.isRequired
}, _temp)) || _class);
exports.default = Notification;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Notification/Notification.js
// module id = 2268
// module chunks = 0